import script from "./ProductionLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductionLayout.vue?vue&type=script&setup=true&lang=js"

import "./ProductionLayout.vue?vue&type=style&index=0&id=11d4286a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11d4286a"]])

export default __exports__